import React from 'react';
import { FormattedMessage } from 'react-intl';

const DimensionsLabel = () => <FormattedMessage defaultMessage='Size' description='fulfillmentPlanner.dimensions' id='cqe5tV' />;

export default DimensionsLabel;
